module.exports = __webpack_public_path__ + "static/img/lange_crub.a39c07f4.jpg";